import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { redirects as anyRedirects, routes as anyRoutes } from './any';
import { redirects as _loggedInExpertRedirects, routes as _loggedInExpertRoutes } from './expert';
import { redirects as _loggedInRedirects, routes as _loggedInRoutes } from './logged-in';
import { redirects as _loggedOutRedirects, routes as _loggedOutRoutes } from './logged-out';
import { redirects as _loggedOutRedirects2, routes as _loggedOutRoutes2 } from './logged-out-2';

export type RouteProps = React.ComponentProps<typeof Route> & {
  layout: React.ComponentType<{ children: React.ReactNode }>;
};
export type RedirectProps = React.ComponentProps<typeof Redirect>;

interface RoutesProps {
  notFound: React.ComponentType;
  redirects?: Array<RedirectProps>;
  routes: Array<RouteProps>;
}

export function Routes({ notFound, redirects = [], routes }: RoutesProps) {
  return (
    <Switch>
      {redirects.map(({ from, to }, i) => (
        <Route key={i} path={from} exact render={() => <Redirect from={from} to={to} />} />
      ))}
      {routes.map(({ path, exact, component }, i) => (
        <Route key={i} path={path} exact={!!exact} component={component ? component : notFound} />
      ))}
      <Route component={notFound} />
    </Switch>
  );
}

export { NotFound as LoggedInExpertNotFound } from './expert';
export { NotFound as NotFoundLoggedIn } from './logged-in';
export { NotFound as NotFoundLoggedOut } from './logged-out';

export const loggedInRedirects = _loggedInRedirects.concat(anyRedirects);
export const loggedInRoutes = _loggedInRoutes.concat(anyRoutes);
export const loggedOutRedirects = _loggedOutRedirects.concat(anyRedirects);
export const loggedOutRoutes = _loggedOutRoutes.concat(anyRoutes);
export const loggedOutRedirects2 = _loggedOutRedirects2.concat(anyRedirects);
export const loggedOutRoutes2 = _loggedOutRoutes2.concat(anyRoutes);
export const loggedInExpertRedirects = _loggedInExpertRedirects.concat(anyRedirects);
export const loggedInExpertRoutes = _loggedInExpertRoutes.concat(anyRoutes);

export { redirects as anyRedirects, routes as anyRoutes } from './any';
